import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js';

/**
 * Format phone number in international format: +33 6 12 34 56 78
 */
export const formatPhoneNumberDisplay = (
  phoneNumber: string | null | undefined,
  countryCode: CountryCode = 'FR'
): string => {
  if (!phoneNumber) return '';

  const parsed = parsePhoneNumberFromString(phoneNumber, countryCode);
  if (!parsed) {
    return phoneNumber;
  }
  return parsed.formatInternational();
};

/**
 * Format phone number in national format: 06 12 34 56 78
 */
export const formatPhoneNumberNational = (
  phoneNumber: string | null | undefined,
  countryCode: CountryCode = 'FR'
): string => {
  if (!phoneNumber) return '';

  const parsed = parsePhoneNumberFromString(phoneNumber, countryCode);
  if (!parsed) {
    return phoneNumber;
  }
  return parsed.formatNational();
};
